import Stack from '@mui/material/Stack';
import { styled } from '@mui/material/styles';

import { VpButton } from '../';

// styles
export const StyledStack = styled(Stack)(({ theme }) => ({
  height: '200px',
  backgroundColor: theme.palette.vpColors.greyLighter,
  display: 'grid',
  alignContent: 'center',
  justifyItems: 'center'
}));

export const StyledVpButton = styled(VpButton)({
  fontSize: '14px',
  marginTop: '10px'
});



// WEBPACK FOOTER //
// ./src/vp-ui/components/VpUpgradePromptBox/styles.js